import { httpWithoutToken, http } from "../helper/http-common";

class LoginDataService {
  login(inputData) {
    return httpWithoutToken.post("/Identity/LogIn", inputData);
  }
  AdminResetPassword(inputData) {
    return httpWithoutToken.post("/Identity/AdminResetPassword", inputData);
  }
  AdminSuperResetPassword(inputData) {
    return httpWithoutToken.post(
      "/Identity/AdminSuperResetPassword",
      inputData
    );
  }
  currency(inputData) {
    return httpWithoutToken.post(
      "/SelectCourency/SelectlanguageForDelar",
      inputData
    );
  }
  GetIndexingStatus(inputData) {
    return http.post("/Identity/GetIndexingStatus", inputData);
  }
}

export default new LoginDataService();
